<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <navbar />

    <v-content class="secondary--text text--darken-2">
      <v-container fill-height>
        <v-row class="fill-height">
          <v-col cols="12">
            <v-row fill-height justify="center">
              <v-col xs="12" sm="8" md="6" lg="4">
                <v-card class="mt-10">
                  <v-card-title
                    class="primary text-center pa-4 secondary--text text--darken-3"
                  >
                    <v-row justify="center">
                      <span
                        class="text-uppercase text-center font-weight-light"
                      >
                        <span class="font-weight-medium">
                          My Details
                        </span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <p>
                      Use this form to update your details. If you leave the
                      <b>New</b> Password fields blank, your password will not
                      be changed.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <m-form
                        v-slot="{ model }"
                        :query="apiEndpoints.updateUser"
                        :params="[userData.id]"
                        :rules="validationRules"
                        :modelSrc="userData"
                        @success="displaySuccess = true"
                        @success-complete="displaySuccess = false"
                        @cancel="$router.back()"
                        lazy-validation
                      >
                        <v-row align="center" justify="center">
                          <m-textinput
                            :model="model"
                            name="name"
                            label="Your Name"
                            required
                          ></m-textinput>
                        </v-row>
                        <v-row align="center" justify="center">
                          <m-textinput
                            :model="model"
                            name="email"
                            label="Your Email Address"
                            required
                          ></m-textinput>
                        </v-row>
                        <v-row>
                          <m-password
                            :model="model"
                            name="current_password"
                            label="Current Password"
                            required
                            ref="passwordInput"
                          ></m-password>
                        </v-row>
                        <v-row>
                          <m-password
                            :model="model"
                            name="password"
                            label="New Password"
                            ref="passwordInput"
                          ></m-password>
                        </v-row>
                        <v-row>
                          <m-password
                            :model="model"
                            name="password_confirmation"
                            label="Repeat New Password"
                          ></m-password>
                        </v-row>
                        <v-row v-if="displaySuccess">
                          <h3 class="primary--text pb-3">
                            <v-icon size="24" class="primary--text"
                              >mdi-check-bold</v-icon
                            >
                            Details updated.
                          </h3>
                        </v-row>
                        <v-row v-else>
                          <m-submit label="Update" :model="model"> </m-submit>
                          <v-btn
                            text
                            color="primary"
                            class="mb-3"
                            @click="model.onFormCancel()"
                          >
                            Cancel
                          </v-btn>
                        </v-row>
                      </m-form>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiEndpoints from "../mixins/api-endpoints";

export default {
  mixins: [apiEndpoints],
  data() {
    return {
      displaySuccess: false,
      validationRules: {
        current_password: model => [
          v => !!v || "Current password is required",
          v => (v && v.length >= 6) || "Password must be at least 6 characters"
        ],
        password: model => [
          v =>
            !v || v.length >= 6 || "New password must be at least 6 characters"
        ],
        password_confirmation: model => [
          v =>
            v == model.values.password ||
            "New password confirmation does not match new password"
        ],
        email: model => [
          v => !!v || "E-mail is required",
          v => /.+@.+\..+/.test(v) || "E-mail must be valid"
        ],
        name: model => [
          v => !!v || "Name is required",
          v => (v && v.length >= 5) || "Name must be at least 5 characters"
        ]
      }
    };
  },
  methods: {
    showError(message) {
      this.$refs.errorBox.showError(message);
    }
  }
};
</script>
